import React, {PropTypes, Component} from 'react';
import {I18N, CONFIG} from '../../../globals/config';
import SignFooter from './sign-footer';
import {FORGOT_STEP} from '../join-modal';

const api = CONFIG.api + 'join_modal/';

class SignIn extends Component {
	constructor( props ){
		super( props );
		this.state = {
			user_login : "",
			user_password : "",
			error_message : ""
		};

		this.onChange     = this.onChange.bind( this );
		this._check_login = this._check_login.bind( this );
	}

	onChange( event ){
		this.state[event.target.name] = event.target.value;
		this.setState( this.state );
	}

	_check_login(){
		let data          = this.state;
		data.subscription = this.props.subscription;
		data.method       = 'check_login';
		data.nonce        = CONFIG.join_modal_nonce;

		$.post( api, data, function( response ){
			if( !_.isObject( response ) || !response.success ){
				this.setState( {
					error_message : I18N.invalid_login
				} )
			} else {
				window.location.reload();
			}
		}.bind( this ) );

	}


	render(){
		return (
			<div className="form-wrap">
				{!_.isEmpty( this.state.error_message ) && <div className="error">{this.state.error_message}</div>}
				<input
					type="text"
					name="user_login"
					value={this.state.user_login}
					onChange={this.onChange}
					placeholder={I18N.email}
				/>
				<input
					type="password"
					name="user_password"
					value={this.state.user_password}
					onChange={this.onChange}
					placeholder={I18N.password}
				/>

				<a className="forgot-password" data-step={FORGOT_STEP} onClick={this.props.changeStep}>
					{I18N.forgot_password}
				</a>

				<input
					className="button button-primary"
					type="submit"
					name="join-submit"
					value={I18N.sign_in}
					onClick={this._check_login.bind( this )}
				/>

				<SignFooter changeStep={this.props.changeStep}/>
			</div>
		)
	}
}

SignIn.propTypes = {
	changeStep : PropTypes.func.isRequired
};


export default SignIn;


// WEBPACK FOOTER //
// ./src/components/modals/join/sign-in.js